/* eslint-disable filename-rules/match */

import { t } from "i18n/i18n";
import { GearSettingsIcon, PersonSingleIcon, StarIcon } from "mds/icons";
import { HomeRoleType } from "utils/urls";

export const roleLabel: Record<HomeRoleType, string> = {
  student: t("home.role.student"),
  instructor: t("home.role.instructor"),
  admin: t("home.role.admin"),
};

export const roleIcon: Record<HomeRoleType, React.ReactNode> = {
  student: <PersonSingleIcon />,
  instructor: <StarIcon />,
  admin: <GearSettingsIcon />,
};
